import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sinalizador-nivel',
  templateUrl: './sinalizador-nivel.component.html',
  styleUrls: ['./sinalizador-nivel.component.scss']
})
export class SinalizadorNivelComponent implements OnInit {

  @Input() nivel:number = 1;

  constructor() { 
    

  }

  ngOnInit() {
    
  }

}
